module.exports = __webpack_public_path__ + "static/WEDDING E&M-90-be4ff96fea9816d62ad760c173fea663.jpg";